import React from "react";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { SectionHeader } from "./About";

export default function Achievements({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <section id="achievements" className="py-24 md:py-32 relative" data-testid="achievements-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="07" overline="Achievements" title="Awards, Honors & Milestones" />
        <div className="mt-14 grid md:grid-cols-2 gap-4">
          {items.map((a, i) => (
            <motion.div
              key={a.id || i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="card-tech p-5 group hover:border-volt/40"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <p className="font-display font-semibold text-base leading-tight group-hover:text-volt transition-colors">
                    {a.title}
                  </p>
                  <p className="text-fog-300 text-sm mt-1">
                    {a.organization}
                  </p>
                  {a.description && (
                    <p className="text-fog-400 text-xs mt-2 leading-relaxed">
                      {a.description}
                    </p>
                  )}
                </div>
                {a.year && (
                  <span className="shrink-0 text-xs font-mono text-volt/80 bg-volt/10 px-2 py-1 rounded">
                    {a.year}
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
